export const WebScriptBackendSymbol = Symbol.for("webScriptBackendSymbol");
